import { render, staticRenderFns } from "./Decoration4.vue?vue&type=template&id=e7e7f4d8&scoped=true"
import script from "./Decoration4.vue?vue&type=script&lang=js"
export * from "./Decoration4.vue?vue&type=script&lang=js"
import style0 from "./Decoration4.vue?vue&type=style&index=0&id=e7e7f4d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e7f4d8",
  null
  
)

export default component.exports